import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useCredits } from '../../context/CreditContext';
import Icons from '../Icons';

const NAV_GROUPS = [

  {
    label: 'Prompt',
    items: [
      { path: '/prompt', label: 'Prompt Writing', Icon: Icons.PenBox, color: '#a78bfa' },
    ],
  },
  {
    label: 'Create',
    items: [
      { path: '/generate', label: 'Generate Image', Icon: Icons.ImgFrame, color: '#c084fc' },
      { path: '/video', label: 'Text to Video', Icon: Icons.FilmStrip, color: '#38bdf8' },
      { path: '/frame2video', label: 'Frame to Video', Icon: Icons.Multishot, color: '#fb7185' },
    ],
  },
  {
    label: 'Edit',
    items: [
      { path: '/multishot', label: 'MultiShot', Icon: Icons.Clapperboard, color: '#f472b6' },
      { path: '/upscale', label: 'Upscale Image', Icon: Icons.Upscale, color: '#34d399' },
      { path: '/edit-video', label: 'Edit Video', Icon: Icons.Scissors, color: '#f59e0b' },
      { path: '/angles', label: 'Different Angles', Icon: Icons.Orbit, color: '#818cf8' },
      { path: '/motionsync', label: 'Motion Sync', Icon: Icons.Motion, color: '#06b6d4' },
      { path: '/lipsync', label: 'Lip-Sync', Icon: Icons.LipSync, color: '#ec4899' },
    ],
  },
  {
    label: 'Discover',
    items: [
      { path: '/explore', label: 'Templates', Icon: Icons.Sparkle, color: '#f59e0b' },
    ],
  },
];

export default function Sidebar({ onShowAuth, isCollapsed, isMobileOpen, setIsMobileOpen }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const { plan } = useCredits();
  const avatarUrl = user?.photoURL || `https://api.dicebear.com/7.x/shapes/svg?seed=${user?.uid || 'guest'}`;
  const displayName = user?.name || user?.email?.split('@')[0] || 'Guest';

  return (
    <>
      {/* Mobile backdrop */}
      {isMobileOpen && (
        <div className="side-overlay" onClick={() => setIsMobileOpen(false)} />
      )}
      
      <aside className={`side ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`}>
        {NAV_GROUPS.map(grp => (
          <React.Fragment key={grp.label}>
            <div className="sgrp">{grp.label}</div>
            {grp.items.map(item => {
              const isOn = location.pathname === item.path;
              return (
                <div
                  key={item.path}
                  className={`sitem ${isOn ? 'on' : ''}`}
                  onClick={() => {
                    navigate(item.path);
                    if (setIsMobileOpen) setIsMobileOpen(false);
                  }}
                >
                  <span className="si" style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    width: 28, height: 28, borderRadius: 8, flexShrink: 0,
                    background: isOn ? `${item.color}22` : 'rgba(255,255,255,0.055)',
                    color: isOn ? item.color : 'var(--t2)',
                    border: isOn ? `1px solid ${item.color}44` : '1px solid rgba(255,255,255,0.07)',
                    transition: 'all 0.2s',
                  }}>
                    <item.Icon sz={14} />
                  </span>
                  <span className="sitem-text">{item.label}</span>
                </div>
              );
            })}
          </React.Fragment>
        ))}

        <div className="sbot">
          {user ? (
            <>
              <div
                className={`sitem ${location.pathname === '/profile' ? 'on' : ''}`}
                onClick={() => {
                  navigate('/profile');
                  if (setIsMobileOpen) setIsMobileOpen(false);
                }}
              >
                <img
                  src={avatarUrl} alt="" className="pf-av-mini"
                  style={{ width: 28, height: 28, borderRadius: 8, objectFit: 'cover', border: '1px solid var(--b2)', flexShrink: 0 }}
                />
                <div className="sitem-info" style={{ display: 'flex', flexDirection: 'column', gap: 0, minWidth: 0 }}>
                  <span className="sitem-text" style={{ fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{displayName}</span>
                  <span className="sitem-plan" style={{ fontSize: 9, color: 'var(--ac3)', textTransform: 'uppercase', fontWeight: 800 }}>{plan} plan</span>
                </div>
              </div>
            </>
          ) : (
            <div className="sitem" onClick={() => {
              if (onShowAuth) onShowAuth();
              if (setIsMobileOpen) setIsMobileOpen(false);
            }} style={{ color: 'var(--ac3)', fontSize: 12, fontWeight: 700 }}>
              <span className="si" style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: 28, height: 28, borderRadius: 8, flexShrink: 0,
                background: 'rgba(167,139,250,0.12)',
                color: '#a78bfa',
                border: '1px solid rgba(167,139,250,0.25)',
              }}>
                <Icons.Sparkle sz={14} />
              </span>
              <span className="sitem-text">Sign up for free</span>
            </div>
          )}
        </div>
      </aside>
    </>
  );
}
